import { gql } from 'apollo-angular'

export const RESET_PASSWORD = gql`
  mutation ResetPasswordUser($password: String!, $token: String!) {
    resetPasswordUser(password: $password, token: $token) {
      token
    }
  }
`
